import { Budget } from "@interfaces/budget-response";
import { SimpleItem } from "@interfaces/item";
import { Modal } from "@interfaces/modal";
import { NfePayload } from "@interfaces/nfe-payload";
import { Servico } from "@interfaces/service";
import { createActionGroup, emptyProps, props } from "@ngrx/store";

export const AppActions = createActionGroup({
  source: "App",
  events: {
    "Queue Request": props<{
      id: string;
    }>(),
    "Resolve Request": props<{
      id: string;
    }>(),
    "Queue Modal": props<{
      modal: Modal;
    }>(),
    "Remove Modal": props<{
      id: string;
    }>(),
    "Select Budget": props<{
      budget: Budget;
    }>(),
    // Mesmo orçamento da obra, mas abrindo a emissão de NFS-e: o cliente da
    // obra vira o tomador. Os serviços continuam vindo do cadastro fiscal.
    "Select Budget For Nfse": props<{
      budget: Budget;
    }>(),
    // Orçamento fechado (obra) abrindo a emissão de NFC-e: itens e cliente
    // vêm da obra; só pagamentos (e CPF opcional) são informados na tela.
    "Select Budget For Nfce": props<{
      budget: Budget;
    }>(),
    "Clear Selected Budget": emptyProps(),
    "Select Item To Edit": props<{
      item: SimpleItem;
    }>(),
    "Clear Selected Item": emptyProps(),
    "Cache Nfe": props<{
      payload: NfePayload;
    }>(),
    "Clear Nfe Cache": emptyProps(),
    "Add Service": props<{
      service: Servico;
    }>(),
    "Update Service Value": props<{
      serviceId: string;
      valor: number | null;
    }>(),
    // Discriminação editada na emissão: vale só para esta nota, o cadastro
    // não muda.
    "Update Service Discriminacao": props<{
      serviceId: string;
      discriminacao: string;
    }>(),
    "Remove Service": props<{
      serviceId: string;
    }>(),
    "Clear Selected Services": emptyProps()
  }
});
